import Button from 'components/shared/Button/Button'
import Icon from 'components/shared/Icon/Icon'
import LevelTag from 'components/shared/LevelTag/LevelTag'
import ProjectPathwayBanner from 'components/shared/ProjectPathwayBanner/ProjectPathwayBanner'
import Tags from 'components/shared/Tags/Tags'
import { getPathwayDetails } from 'helpers/Project'
import { tagsLinks } from 'helpers/tags'
import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'
import { Link } from 'react-router-dom'
import { addFavourite, removeFavourite } from 'redux/actions/FavouriteActions'

import './ProjectHeader.scss'

const linksList = (linksArray) =>
  linksArray.reduce((acc, links) => {
    return acc.concat(
      Object.entries(links).map(([key, link], index) => (
        <Link
          key={`${index}-${key}`}
          className="c-project-header__tag-link"
          to={link.url}
        >
          {link.label}
        </Link>
      ))
    )
  }, [])

const projectCompletedNotice = (t) => (
  <>
    <h2 className="c-project-header__project-complete-notice">
      <span className="c-project-header__project-complete-icon" />
      {t('project.header.congratulations')}
    </h2>
  </>
)

const dispatchFavourite = (
  dispatch,
  favourite,
  authentication,
  locale,
  projectId
) => {
  const authToken =
    authentication && authentication.user
      ? authentication.user.access_token
      : null
  if (authToken) {
    if (favourite) {
      dispatch(removeFavourite(locale, authToken, projectId))
    } else {
      dispatch(addFavourite(locale, authToken, projectId))
    }
  }
}

export const ProjectHeader = ({
  authentication,
  dispatch,
  favourite = false,
  hardware,
  included,
  imageUrl,
  loading,
  locale,
  projectComplete,
  projectId,
  software,
  t,
  title,
}) => {
  const {
    slug = null,
    title: pathwayTitle = null,
    difficultyLevel = null,
    technologyTheme = null,
  } = getPathwayDetails(included)

  const links = linksList([
    tagsLinks(locale, t, hardware, 'hardware'),
    tagsLinks(locale, t, software, 'software'),
  ])
  const toggleFavourite = () =>
    dispatchFavourite(dispatch, favourite, authentication, locale, projectId)

  return (
    !loading && (
      <>
        <ProjectPathwayBanner
          slug={slug}
          pathwayTitle={pathwayTitle}
          locale={locale}
          t={t}
        />
        <div className="c-project-header-wrapper">
          <div
            className={`c-project-header ${
              projectComplete ? 'c-project-header--project-complete' : ''
            }`}
          >
            <div className="c-project-header__info">
              <LevelTag
                level={`${difficultyLevel}`}
                technology={technologyTheme}
              />
              <h1 className="c-project-header__title">{title}</h1>
              {links.length > 0 && <Tags locale={locale} labels={links} />}
              {authentication.user && (
                <Button
                  textAlways={true}
                  type="primary"
                  className={'sc-pr-pathway-project__button'}
                  onClick={toggleFavourite}
                  icon={
                    <Icon
                      type={favourite ? 'cross' : 'tick'}
                      className="c-project-header__text_link_icon"
                    />
                  }
                  text={
                    favourite
                      ? t('project.header.favourite.added')
                      : t('project.header.favourite.addto')
                  }
                />
              )}
            </div>
            {imageUrl && (
              <figure className="c-project-header__illustration">
                <img
                  alt=""
                  className={`c-project-header__image`}
                  src={imageUrl}
                />
              </figure>
            )}
          </div>
        </div>
        {projectComplete ? projectCompletedNotice(t) : ''}
      </>
    )
  )
}

ProjectHeader.propTypes = {
  authentication: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  favourite: PropTypes.bool,
  hardware: PropTypes.array,
  imageUrl: PropTypes.string,
  included: PropTypes.object,
  locale: PropTypes.string.isRequired,
  projectComplete: PropTypes.bool.isRequired,
  projectId: PropTypes.number,
  software: PropTypes.array,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
}

export default withNamespaces('translations')(ProjectHeader)
